import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Function to normalize category strings (e.g., FOOD_AND_DRINK -> Food And Drink)
export function normalizeCategory(category: string | undefined | null): string {
  if (!category) {
    return "";
  }
  return category
    .toLowerCase() // Convert to lowercase
    .replace(/_/g, ' ') // Replace underscores with spaces
    .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize first letter of each word
}

// Function to shorten merchant names
export function shortenMerchantName(name: string | undefined | null, maxLength: number = 30): string {
  if (!name) {
    return "N/A"; // Or an empty string, depending on desired behavior
  }

  const lowerName = name.toLowerCase();

  if (lowerName.startsWith("internet transfer")) {
    return "Internet Transfer";
  }
  if (lowerName.startsWith("e-transfer")) {
    return "E-Transfer";
  }
  if (lowerName.startsWith("preauthorized debit")) {
    const remainingPart = name.substring("preauthorized debit".length).trim();
    return `Preauth Debit${remainingPart ? ` - ${remainingPart}` : ""}`; // Optionally keep the rest
    // Or simply: return "Preauth Debit";
  }
  // Add check for Payment Thank You / Paiement Merci
  if (lowerName.startsWith("payment thank you") || lowerName.startsWith("paiemen t merci")) {
    return "Payment";
  }
  // Add check for Payroll (e.g., PAY COMPANY_NAME)
  if (lowerName.startsWith("pay ")) {
    // const companyName = name.substring(4).trim(); // Get text after "PAY " // Removed company name extraction
    // Optionally truncate companyName if it's still too long
    // if (companyName.length > maxLength - 10) { // Adjust maxLength as needed
    //   companyName = companyName.substring(0, maxLength - 13) + "...";
    // }
    // return `Payroll - ${companyName}`; // Changed to return just "Payroll"
    return "Payroll";
  }

  // Fallback: Truncate if too long
  if (name.length > maxLength) {
    return name.substring(0, maxLength) + "...";
  }

  return name; // Return original name if it fits and no pattern matched
}
